
export default {
  name: 'contrast',
  data() {
    return {
      showDouble: false
    };

  },
  components: {

  },
  computed: {},
  props: {
  },
  watch: {
  },
  mounted() {
  },
  created() {

  },
  methods: {
    comparative(type) {
      this.$emit('comparativeS', type);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/leftmenu/contrast/contrast.js